/// <reference path="../../../../node_modules/react-datetime/react-datetime.d.ts" />

import * as React from 'react';
import { IDetailViewModel } from '../Types';
import { ICurrency } from '../Types';
import { appendCurrencyInfo } from '../ReceivableFunctions';
import moment from 'moment';

interface IProps extends IDetailViewModel {
    currency: ICurrency;
    amount: number;
    paid: number;
    balance: number;
    exchangeDifference: number;
    rowClass?: string;
}

const ReceivableDetail = (props: IProps) => {
    return (
        <tr className={props.rowClass}>
            <td>{moment(props.date).format('L')}</td>
            <td>{props.customer}</td>
            <td>{props.invoice}</td>
            <td>{appendCurrencyInfo(props.currency, props.amount)}</td>
            <td>{appendCurrencyInfo(props.currency, props.paid)}</td>
            <td>{appendCurrencyInfo(props.currency, props.exchangeDifference)}</td>
            <td>{appendCurrencyInfo(props.currency, props.balance)}</td>
        </tr>
    );
};

export default ReceivableDetail;
